import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93f5908e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "warning-wrapper" }
const _hoisted_2 = { class: "com-head" }
const _hoisted_3 = {
  key: 0,
  class: "warning-date-box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-rili" }, null, -1))
const _hoisted_5 = { class: "warning-select-wrapper" }
const _hoisted_6 = { class: "warning-select" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-dianpu1" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-arrow-down-filling" }, null, -1))
const _hoisted_9 = { class: "warning-infos" }
const _hoisted_10 = ["onClick"]

import { ref, computed, onActivated, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import type { CalendarInstance } from 'vant'

import { getShops, getWarning } from '@/api/shop'
import { formatTime, comDialog, getValueBykey } from '@/utils'
import { IShop, IWarningInfo, IWarningEvent } from '@/utils/interface'
import ComHeader from '@/components/ComHeader/index.vue'
import warningItem from '@/components/WarningItem/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isInit = ref(true)
const columns = ref([])
const showPicker = ref(false)
const warningType = ref('1')
const timeType = ref(5)
const curPage = ref(1)
const curSize = ref(20)
const startTime = ref('')
const endTime = ref('')
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const list = ref<IWarningInfo[]>([])
const events = ref<IWarningEvent[]>([])
const dateValue = computed(() => {
  return startTime.value ? `${startTime.value} 至 ${endTime.value}` : ''
})
// eslint-disable-next-line vue/return-in-computed-property
const dateTitle = computed(() => {
  const timestamp = +new Date()
  switch (timeType.value) {
    case 1:
      return formatTime(timestamp, 'date')
    case 2:
      return formatTime(timestamp - 24 * 60 * 60 * 1000, 'date')
    case 3:
      return `${formatTime(
        timestamp - 6 * 24 * 60 * 60 * 1000,
        'date'
      )} 至 ${formatTime(timestamp, 'date')}`
    case 4:
      return `${formatTime(
        timestamp - 29 * 24 * 60 * 60 * 1000,
        'date'
      )} 至 ${formatTime(timestamp, 'date')}`
    case 5:
      return dateValue.value || '全部时间'
  }
})

const init = () => {
  const route = useRoute()
  if (route.query.type) {
    warningType.value = route.query.type as string
  }

  if (route.query.time) {
    timeType.value = Number(route.query.time)
  } else {
    timeType.value = 5
  }
}
init()

const curEvent = ref<string>('')
const handleEvent = (type: string) => {
  if (curEvent.value === type) {
    curEvent.value = ''
  } else {
    curEvent.value = type
  }
  refreshing.value = true
  onRefresh()
}

getShops().then((res: any) => {
  columns.value = res.storeList
})

const switchHead = (index: number, flag?: boolean) => {
  if (index === timeType.value && !flag) return
  endTime.value = ''
  startTime.value = ''
  timeType.value = index
  refreshing.value = true
  onRefresh()
}

const calendarRef = ref<CalendarInstance | null>()
const calendarOpen = () => {
  if (!startTime.value) {
    nextTick(() => {
      const cal = calendarRef.value as any
      const dom = document.querySelector('.van-calendar__body') as any
      console.log('cal~~', cal)
      const back = dom.scrollTop
      setTimeout(() => {
        dom.scrollTop = back - 5
        console.log('start', back - 5)
      }, 10)
      setTimeout(() => {
        dom.scrollTop = back
        console.log('end', back)
        cal.scrollToDate(new Date())
      }, 100)
    })
  }
}

const onLoad = () => {
  if (refreshing.value) {
    list.value = []
    refreshing.value = false
    curPage.value = 1
  }
  setTimeout(() => {
    getWarning({
      storeNo: store.getters.storeNo,
      timeType: timeType.value,
      warningType: warningType.value,
      startTime: startTime.value,
      endTime: endTime.value,
      page: curPage.value,
      size: curSize.value,
      exceptionType: curEvent.value
    }).then((res: any) => {
      if (curPage.value === 1) {
        list.value = res.warningInfoList
      } else {
        list.value = list.value.concat(res.warningInfoList)
      }
      loading.value = false

      if (list.value.length >= res.row) {
        finished.value = true
      } else {
        curPage.value += 1
      }
      events.value = res.eventCountList
    })
  }, 1000)
}

const onRefresh = () => {
  // 清空列表数据
  finished.value = false

  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  onLoad()
}

// interface WarningResult {
//   row: number
//   warningInfoList: IWarningInfo[]
// }

const store = useStore()
const onConfirm = (value: IShop) => {
  store.commit('store/setStoreNo', value.storeNo)
  showPicker.value = false
  refreshing.value = true
  onRefresh()
}

const show = ref(false)
const onConfirmDate = (values: Date[]) => {
  const [start, end] = values
  show.value = false
  startTime.value = formatTime(start.getTime(), 'date')
  endTime.value = formatTime(end.getTime(), 'date')
  refreshing.value = true
  onRefresh()
}

onActivated(() => {
  const route = useRoute()
  if (!route.meta.isBack && !isInit.value) {
    curEvent.value = ''
    init()
    switchHead(Number(timeType.value), true)
    // if (timeType.value === 5) {
    //   nextTick(() => {
    //     // switchHead(5)
    //     console.log(calendarRef.value)
    //     // eslint-disable-next-line @typescript-eslint/no-extra-semi
    //     ;(calendarRef.value as CalendarInstance).reset()
    //   })
    // }
  }
  isInit.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: warningType.value === '1' ? '安全生产监督预警' : '绩效巡检监督预警'
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_router_link, {
          tag: "i",
          to: "/shop",
          class: "iconfont icon-dianpu"
        })
      ]),
      nav: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: _normalizeClass({ actived: timeType.value === 5 }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (switchHead(5)))
          }, "全部", 2),
          _createElementVNode("a", {
            class: _normalizeClass({ actived: timeType.value === 1 }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (switchHead(1)))
          }, "今天", 2),
          _createElementVNode("a", {
            class: _normalizeClass({ actived: timeType.value === 2 }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (switchHead(2)))
          }, "昨天", 2),
          _createElementVNode("a", {
            class: _normalizeClass({ actived: timeType.value === 3 }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (switchHead(3)))
          }, "近7天", 2),
          _createElementVNode("a", {
            class: _normalizeClass({ actived: timeType.value === 4 }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (switchHead(4)))
          }, "近30天", 2)
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    (timeType.value === 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_van_field, {
            modelValue: _unref(dateValue),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(dateValue) ? (dateValue).value = $event : null)),
            placeholder: "选择开始时间 - 结束时间",
            readonly: "",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (show.value = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_calendar, {
            ref_key: "calendarRef",
            ref: calendarRef,
            show: show.value,
            "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((show).value = $event)),
            "default-date": null,
            "allow-same-day": true,
            title: "",
            type: "range",
            "max-date": new Date(),
            "min-date": new Date(2019, 7, 1),
            color: "#fe7001",
            onConfirm: onConfirmDate,
            onOpen: calendarOpen
          }, null, 8, ["show", "max-date", "min-date"]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showPicker.value = true)),
          class: "warning-select-value"
        }, _toDisplayString(_unref(store).getters.storeNo && columns.value.length
              ? _unref(getValueBykey)(
                  'storeNo',
                  _unref(store).getters.storeNo,
                  columns.value,
                  'storeName'
                )
              : '全部门店'), 1),
        _createVNode(_component_van_popup, {
          show: showPicker.value,
          "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showPicker).value = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              columns: columns.value,
              "columns-field-names": { text: 'storeName' },
              onCancel: _cache[9] || (_cache[9] = ($event: any) => (showPicker.value = false)),
              onConfirm: onConfirm
            }, null, 8, ["columns"])
          ]),
          _: 1
        }, 8, ["show"]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (item) => {
          return (_openBlock(), _createElementBlock("dl", {
            key: item.eventType,
            onClick: ($event: any) => (handleEvent(item.eventType))
          }, [
            _createElementVNode("dt", {
              class: _normalizeClass([curEvent.value === item.eventType ? 'warning' : ''])
            }, _toDisplayString(item.qty), 3),
            _createElementVNode("dd", {
              class: _normalizeClass([curEvent.value === item.eventType ? 'warning' : ''])
            }, _toDisplayString(item.eventName), 3)
          ], 8, _hoisted_10))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_divider, { style: { color: '#D1D1D1', borderColor: '#D1D1D1', margin: '12px 54px' } }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(dateTitle)), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[11] || (_cache[11] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          class: "warning-list",
          offset: "5",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createVNode(warningItem, { list: list.value }, null, 8, ["list"])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})